<button type="button" class="pill trigger" [class.has-leading-icon]="icon()" [disabled]="disabled()"
  cdkOverlayOrigin #trigger="cdkOverlayOrigin" (click)="toggle()">
  @if (icon(); as glyph) {
    <i class="material-icons">{{ glyph }}</i>
  }
  <span class="text">{{ label() }}</span>
  <i class="material-icons caret">
    {{ open() ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
  </i>
</button>

<ng-template cdkConnectedOverlay appOverlayPanel matchTriggerWidth
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="open()"
  [panelPositions]="positions()"
  (panelClose)="open.set(false)">
  <ul class="action-menu">
    @for (item of items(); track item.value) {
      <li [class.no-icon]="!item.icon" [class.muted]="item.muted" (click)="select(item)">
        @if (item.icon; as glyph) {
          <i class="material-icons">{{ glyph }}</i>
        }
        <span class="title">{{ item.label }}</span>
      </li>
    }
  </ul>
</ng-template>
